import productsNo from '../resources/no/products.json';
import productsSe from '../resources/se/products.json';
import { ProductLanguageResources } from '../types/ProductResources';

export const productsI18nResources: ProductLanguageResources = {
  no: { products: productsNo },
  se: { products: productsSe },
};
